module.exports = __webpack_public_path__ + "static/media/AP_NES_Z1.c68414d2.png";